/**
 * 通知 Inbox 里 comment mention 的 parent entity 展示/跳转映射。
 * 跟 mobile NotificationItem.tsx 的同名 helper 保持一致。
 */

/**
 * 把后端的 entityTypeCode (task / intent / ...) 映射成用户友好显示。
 * intent 在 UI 上一律叫 "issue";其它 type 原样返回(小写)。
 */
export const entityTypeDisplay = (type?: string): string => {
  if (!type) return ''
  if (type === 'intent') return 'issue'
  if (type === 'task_expense') return 'material request'
  return type
}

/**
 * 把后端 entityTypeCode 映射成对应的前端路由/深链。
 * task → /tasks/:id, intent → /intents/:id (再由该路由转 /intents?intentId= 在
 *   Intents 列表页打开 IntentDetail flyout,见 app/routes/main/intents/$id.tsx;
 *   mobile 是 /issues/:id,web 没有 /issues 路由,不能照搬),
 * purchase → /procurement?purchaseId=:id (procurement 页 mount 时消费该参数打开详情 flyout),
 * task_expense → /material-requests?id=:id (material-requests 页用该参数打开 expense flyout),
 * review → /reviews?id=:id (reviews 页消费该参数打开 review 详情 flyout),
 * 其它返回 undefined(不生成链接)。
 */
export const entityHref = (type?: string, id?: string): string | undefined => {
  if (!type || !id) return undefined
  if (type === 'task') return `/tasks/${id}`
  if (type === 'intent') return `/intents/${id}`
  if (type === 'purchase') return `/procurement?purchaseId=${id}`
  if (type === 'task_expense') return `/material-requests?id=${id}`
  if (type === 'review') return `/reviews?id=${id}`
  return undefined
}
